import React, { Component } from "react";
import { Form } from "antd";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

class FormItem extends Component {
  render() {
    const label = (
      <FormattedMessage
        id={`Attribute.${this.props.model}.${this.props.attribute}`}
        defaultMessage={_.startCase(this.props.attribute)}
      />
    );

    return (
      <Form.Item
        label={label}
        hasFeedback={this.props.hasFeedback}
        validateStatus={this.props.validateStatus}
        help={this.props.help}
        style={{
          display: this.props.hidden ? "none" : "block"
        }}
        colon={false}
      >
        {this.props.children}
      </Form.Item>
    );
  }
}

export default FormItem;



// WEBPACK FOOTER //
// ./src/inputs/FormItem.js